import React, { useState, useMemo } from 'react';
import { FormControl } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { filterArray } from '../../services/utils';

const readOnlyColumns = [
  {
    name: 'Trabajador',
    selector: row => row.fullName,
    sortable: true,
    wrap: true
  },
  {
    name: 'Cargo',
    selector: row => row.jobTitle,
    sortable: true,
    wrap: true
  },
  {
    name: 'Área',
    selector: row => row.jobManagement,
    sortable: true,
    wrap: true
  },
  {
    name: 'Proceso de Inscripción',
    selector: row => row.translatedAdmission,
    sortable: true
  },
  {
    name: 'Estado',
    selector: row => row.translatedStatus,
    sortable: true
  }
];

const CourseParticipantsTable = ({ employeeCourses = [] }) => {
  const [textInput, setTextInput] = useState('');

  const filteredEmployeeCourses = useMemo(() => {
    return filterArray(employeeCourses, textInput, [
      'fullName',
      'jobTitle',
      'jobManagement',
      'translatedAdmission',
      'translatedStatus'
    ]);
  }, [textInput, employeeCourses]);

  const subHeaderComponent = useMemo(
    () => (
      <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
        <FormControl
          placeholder="Buscar"
          value={textInput}
          onChange={e => setTextInput(e.target.value)}
          style={{ maxWidth: '300px' }}
        />
      </div>
    ),
    [textInput]
  );

  return (
    <DataTable
      columns={readOnlyColumns}
      data={filteredEmployeeCourses}
      pagination
      paginationPerPage={15}
      paginationRowsPerPageOptions={[5, 10, 15, 50]}
      paginationComponentOptions={{
        rowsPerPageText: 'Filas por pagina:',
        rangeSeparatorText: 'de'
      }}
      noDataComponent={<div style={{ paddingBottom: 30 }}>No se encontraron datos.</div>}
      noHeader
      subHeader
      subHeaderComponent={subHeaderComponent}
      responsive
      fixedHeader
      className="custom-data-table"
    />
  );
};

export default CourseParticipantsTable;
